import * as THREE from 'three';
import CeilingLightFixture from './CeilingLightFixture.js'
import FramedWallPicture from './FramedWallPicture.js'
import Drone from './Drone.js'
import Book from './Book.js'
import CoffeeTable from './CoffeeTable.js'
import Phobject from './Phobject.js'
import Desk from './Desk.js'
import Podium from './Podium.js'
import Placard from './Placard.js'
import Block from './Block.js'

export default class Room extends Phobject{
    constructor(scene, world){
        super();
        this.world = world;
        this.init(scene)
    }

    getDrone() {
        return this.drone;
    }

    

    init(scene){
        this.group = new THREE.Group();
        let crateImage = require('../assets/crate.gif');
        let dtjsFront = require('../assets/dtjsfront.jpg');
        let dtjsBack = require('../assets/dtjsback.jpg');
        let dtjsSpine = require('../assets/dtjsspine.jpg');

        let ceilingLightFixture = new CeilingLightFixture(scene)
        ceilingLightFixture.position.set(0,8,0);
        //light.position.set(0, 8, 0);
        this.group.add(ceilingLightFixture);

        // Wall Art
        let cratePic = new FramedWallPicture(crateImage)
        cratePic.position.set(0,2.0,-10);
        this.group.add(cratePic);

        this.addPhobject(
            new Placard([
                'The Crate Of Destiny',
                'Hello, World!, 2003', 
                'Unknown',
                'Oil on canvas',
                '',
                'Experimental collection',
            ]),
            new THREE.Vector3(2,1.5,-9.99)
        );        

        let fractalTriangle = new FramedWallPicture(require('../assets/Serpinski.png'))
        fractalTriangle.position.set(-10,2.0,0);
        fractalTriangle.rotation.y = Math.PI/2;
        this.group.add(fractalTriangle);

        
        this.addPhobject(
            new Placard([
                `Serpinski's Triangle, colorized`,
                'Fractals in Vue, 2020', 
                'Colby Hearn',
                'Oil on canvas',
                '',
                'Experimental collection',                
            ]),
            new THREE.Vector3(-9.99,1.5,-2),
            new THREE.Vector3(0,Math.PI/2,0)
        );        

        // Drone  
        //TODO: I thinkt I need to have a Obgen base class that phobject inherits so that
        // a) anything can be focusable
        // b) physical things are focusable too
        this.drone = new Drone();
        //let obj = this.drone.getObject()
        //obj.position.set(3,1,3) // because right now, this drone cannot be focus because it's not in the phobject list because it's nolonger a phobject
        //this.group.add(obj);        
        
        
        this.addPhobject(
            this.drone, 
            new THREE.Vector3(0,4,-.50)
        );

        // Books
        this.addPhobject(
            new Book(crateImage,crateImage,crateImage ), 
            new THREE.Vector3(0,2.5,0)
        );
        this.addPhobject(
            new Book(crateImage,crateImage,crateImage ), 
            new THREE.Vector3(0,2.5,.1)
        );
        this.addPhobject(
            new Book(dtjsFront,dtjsBack,dtjsSpine ), 
            new THREE.Vector3(0,2.5,.2)
        );

        // Coffee Table
        this.addPhobject(
            new CoffeeTable(crateImage),
            new THREE.Vector3(0,1.5,0)
        );

        // Desk
        this.addPhobject(
            new Desk(),
            new THREE.Vector3(5,.6,-4)
        );

        // Blocks
        this.addPhobject(
            new Block(0xff0000),
            new THREE.Vector3(5,1.,-4)
        );

        this.addPhobject(
            new Block(0x00ff00),
            new THREE.Vector3(5.025,1.06,-4)
        );

        this.addPhobject(
            new Block(0x0000ff),
            new THREE.Vector3(5.05,1.0,-4)
        );
        

        //Podium
        this.addPhobject(
            new Podium(),
            new THREE.Vector3(9,1.5,-4)
        );
        
        // room walls
        let dim = new THREE.Vector3(20,10,20);
        var texture = new THREE.TextureLoader().load( require('../assets/crate.gif') );
        var geometry = new THREE.BoxBufferGeometry( dim.x,dim.y, dim.z );
        var material = new THREE.MeshPhongMaterial( { 
            color: 0xafafa8, 
            //map: texture ,             
            side: THREE.DoubleSide
        });

        this.mesh = new THREE.Mesh( geometry, material );
        this.mesh.position.y = dim.y/2;
        
        this.group.add(this.mesh)
        scene.add(this.group);

        // physics
        let thickness = 1
        this.world.add({ size:[dim.x, thickness, dim.z], pos:[0,dim.y+thickness/2,0] }); // ceiling
        this.world.add({ size:[dim.x, thickness, dim.z], pos:[0,-thickness/2,0] }); // ground
        this.world.add({ size:[thickness, dim.y, dim.z], pos:[dim.x/2,dim.y/2,0] }); // right wall
        this.world.add({ size:[thickness, dim.y, dim.z], pos:[-dim.x/2,dim.y/2,0] }); // left wall
        this.world.add({ size:[dim.x, dim.y, thickness], pos:[0,dim.y/2,dim.z/2] }); // front wall
        this.world.add({ size:[dim.x, dim.y, thickness], pos:[0,dim.y/2,-dim.z/2] }); // back wall

        

        


    }


}
